import { render } from "./UserLayoutPanel.vue?vue&type=template&id=3db0d420"
import script from "./UserLayoutPanel.vue?vue&type=script&lang=js"
export * from "./UserLayoutPanel.vue?vue&type=script&lang=js"

import "./UserLayoutPanel.vue?vue&type=style&index=0&id=3db0d420&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__